/* eslint-disable no-warning-comments */
// @ts-check

import classNames from 'classnames'
import * as React from 'react'
import {MARK_LINK, NODE_HEADING, render} from 'storyblok-rich-text-react-renderer'

import {isEmptyRichtext} from '@/common/utils'
import Link from '@/components/Link'

const themes = {
  light: 'text-white',
  dark: 'text-purple-900',
}

/**
 * Renders a component from Storyblok Rich Text
 * @param {Object} props - The props object for the component
 * @param {React.ElementType} [props.as='div'] - The HTML tag to render as
 * @param {Object} props.content - The Storyblok Rich Text to render
 * @param {'m' | 'l' | 'l-medium'} [props.size='l'] - The size of the text
 * @param {'dark' | 'light'} [props.theme='dark'] - The color theme
 * @param {string} [props.className=''] - Additional class names
 * @returns {JSX.Element|null} - The rendered component or null if Rich Text is empty
 */
const Content = ({as: Tag = 'div', content, size = 'l', theme = 'dark', className = ''}) => {
  return isEmptyRichtext(content) ? null : (
    <Tag className={classNames('content', size, themes[theme], className)}>
      {render(content, {
        nodeResolvers: {
          [NODE_HEADING]: (children) => <p>{children}</p>,
        },
        markResolvers: {
          [MARK_LINK]: (children, props) => {
            const {href} = props
            let modProps = props
            if (!href.endsWith('/')) {
              modProps.href = href + '/'
            }
            return (
              <Link
                link={modProps}
                id={undefined}
                className={undefined}
                onClick={undefined}
                activeClassName={undefined}
                obfuscate={undefined}
              >
                {children}
              </Link>
            )
          },
        },
      })}
    </Tag>
  )
}

export default Content
